module.exports = __webpack_public_path__ + "img/transition_connect_tp.c8005f05.png";